/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 文章列表
export function findList(query) {
    return axios({
        url: "/admin/find/find/findList",
        method: "get",
        params: query
    });
}

// 文章发布
export function findCeate(data) {
    return axios({
        url: "/admin/find/find/findCeate",
        method: "post",
        data: data
    });
}

// 文章详情（编辑回显）
export function findDetail(query) {
    return axios({
        url: "/admin/find/find/findDetail",
        method: "get",
        params: query
    });
}

// 20个常用标签
export function cateCommonlyList(query) {
    return axios({
        url: "/admin/find/find/cateCommonlyList",
        method: "get",
        params: query
    });
}

// 标签添加
export function createAdd(data) {
    return axios({
        url: "/admin/find/find/createAdd",
        method: "post",
        data: data
    });
}

// 标签添加
export function getUploadImage(data) {
    return axios({
        url: "/admin/app/Users/getUploadImageScreen",
        method: "post",
        data: data
    });
}
// 文章删除
export function findDel(data) {
    return axios({
        url: "/admin/find/find/findDel",
        method: "post",
        data: data
    });
}

// 立即发布
export function findSend(data) {
    return axios({
        url: "/admin/find/find/findSend",
        method: "post",
        data: data
    });
}


// 20个常用标签
export function advertStatus(query) {
    return axios({
        url: "/admin/find/find/advertStatus",
        method: "get",
        params: query
    });
}


// 20个常用标签
export function changeTime(query) {
    return axios({
        url: "/admin/find/find/changeTime",
        method: "get",
        params: query
    });
}

// 修改发布时间
export function changeTimeUpd(data) {
    return axios({
        url: "/admin/find/find/changeTimeUpd",
        method: "post",
        data: data
    });
}


// weight 
export function weightList(query) {
    return axios({
        url: "/admin/reuse/sysconfig/getweight",
        method: "get",
        params: query
    });
}

export function weightUpd(query) {
    return axios({
        url: "/admin/reuse/sysconfig/setweight",
        method: "post",
        data: query
    });
}

// 财富 2.1 新增

// 用户Plus内容列表
export function findUserList(query) {
    return axios({
        url: "/admin/find/find/findUserList",
        method: "get",
        params: query
    });
}

// 用户plus文章审核不通过
export function ExamineSubmit(query) {
    return axios({
        url: "/admin/find/find/ExamineSubmit",
        method: "get",
        params: query
    });
}

// 用户plus文章发布
export function findCeateUserArticle(data) {
    return axios({
        url: "/admin/find/find/findCeateUserArticle",
        method: "post",
        data: data
    });
}

// 用户plus文章  立即发布
export function findSendUserArticle(data) {
    return axios({
        url: "/admin/find/find/findSendUserArticle",
        method: "post",
        data: data
    });
}


// 主编入口
export function findEditorList(query) {
    return axios({
        url: "/admin/find/find/findEditorList",
        method: "get",
        params: query
    });
}

// 主编保存
export function findEditorSave(data) {
    return axios({
        url: "/admin/find/find/findEditorSave",
        method: "post",
        data: data
    });
}



// 开屏图片新增/修改
export function screenCeate(data) {
    return axios({
        url: "/admin/app/users/screenCeate",
        method: "post",
        data: data
    });
}

// 开屏图片删除
export function screenDel(data) {
    return axios({
        url: "/admin/app/users/screenDel",
        method: "post",
        data: data
    });
}


// 开屏图片列表
export function screenList(data) {
    return axios({
        url: "/admin/app/users/screenList",
        method: "post",
        data: data
    });
}

// 开屏图片状态修改
export function openScreenStatus(data) {
    return axios({
        url: "/admin/app/users/openScreenStatus",
        method: "post",
        data: data
    });
}

// 开屏图片详情
export function screenDetail(data) {
    return axios({
        url: "/admin/app/users/screenDetail",
        method: "post",
        data: data
    });
}


